import { useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import moment from "moment-timezone";

import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Flex from "../common/Flex";
import Avatar from "../common/Avatar";
import avatorImg from "../../assets/img/placeholders/avatar.png";

import Collapse from "./Collapse";

const Notification = ({
  avatar,
  className,
  unread,
  flush,
  action,
  createdOn,
  metaData,
  reportId,
}) => {
  const [openCollapse, setOpenCollapse] = useState(false);

  return (
    <div
      className={classNames(
        "notification",
        { "notification-unread": unread, "notification-flush": flush },
        className,
      )}>
      <div className="notification-body">
        <Flex justifyContent={"flex-start"}>
          <div className="notification-avatar">
            {avatar ? (
              <Avatar {...avatar} className="me-3" />
            ) : (
              <Avatar src={avatorImg} className="me-3" />
            )}
          </div>
          <div style={{ position: "relative" }}>
            <p className="mb-1">{action}</p>
            <span className="notification-time">
              {moment(createdOn)
                .tz("Australia/Brisbane")
                .format("DD-MM-YYYY, h:mm A")}
            </span>
          </div>
          {(metaData?.reason || reportId) && (
            <span
              className="px-4"
              style={{ position: "absolute", right: 0 }}
              onClick={() => setOpenCollapse(!openCollapse)}>
              <FontAwesomeIcon
                icon={openCollapse ? faAngleUp : faAngleDown}
                className="text-500 fw-normal cursor-pointer"
                size="lg"
              />
            </span>
          )}
        </Flex>

        <Collapse
          metaData={metaData}
          openCollapse={openCollapse}
          reportId={reportId}
        />
      </div>
    </div>
  );
};

Notification.propTypes = {
  // avatar: PropTypes.shape(Avatar.propTypes),
  time: PropTypes.string.isRequired,
  className: PropTypes.string,
  unread: PropTypes.bool,
  flush: PropTypes.bool,
  emoji: PropTypes.string,
  children: PropTypes.node,
};

Notification.defaultProps = { unread: false, flush: false };

export default Notification;
